import React, { Component, Fragment } from "react";

import { formatDistance } from "date-fns";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ShareIcon from "@mui/icons-material/Share";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { ClickAwayListener } from "@mui/base";
import { styled } from "@mui/material/styles";
import Share from "../commons/Share";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import postService from "../../services/postService";
import { IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import userService from "../../services/userService";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import { withSnackbar } from "./../../hocs/withSnackbar";
import Username from "./Username";

import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";

const now = new Date();

function getPostDate(creationDate) {
  return formatDistance(new Date(creationDate), now, {
    addSuffix: true,
  });
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 200,
    fontSize: 15,
    fontFamily: "inherit",
    padding: 0,
    boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 20%)",
  },
}));

class Post extends Component {
  state = {
    showShareTooltip: false,
    showDeleteConfirmationDialog: false,
    bookmarked: this.props.post.bookmarked,
    liked: this.props.post.liked,
    score: this.props.post.score,
    deleteLoading: false,
  };

  setShareTooltip = (value) => {
    this.setState({
      showShareTooltip: value,
    });
  };

  toggleBookmark = async (e) => {
    e.preventDefault();
    try {
      const { post } = this.props;
      const response = await postService.bookmark(post.id);
      const state = response.data.data;
      this.setState({
        bookmarked: state,
      });
    } catch (err) {
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to toggle bookmark: an error occurred",
          "error"
        );
      }
    }
  };

  toggleLike = async (e) => {
    e.preventDefault();
    try {
      const { post } = this.props;
      const response = await postService.like(post.id);
      const { state, score } = response.data.data;
      this.setState({
        liked: state,
        score,
      });
    } catch (err) {
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to toggle like: an error occurred",
          "error"
        );
      }
    }
  };

  deletePost = async () => {
    try {
      this.setState({
        deleteLoading: true,
      });
      const { post } = this.props;
      const response = await postService.deletePost(post.id);
      this.setState({
        deleteLoading: false,
        showDeleteConfirmationDialog: false,
      });
      this.props.onDelete();
    } catch (err) {
      this.setState({
        deleteLoading: false,
        showDeleteConfirmationDialog: false,
      });
      if (err?.response?.data?.message) {
        this.props.showMessage(err.response.data.message, "error");
      } else {
        this.props.showMessage(
          "Failed to delete post: an error occurred",
          "error"
        );
      }
    }
  };

  render() {
    const {
      history,
      post,
      style,
      isLink = true,
      showPostActions = true,
    } = this.props;
    const appUrl = process.env.REACT_APP_URL;
    const relativePostUrl = `/post/${post.id}`;
    const postUrl = `${appUrl}${relativePostUrl}`;
    const { category } = post;
    const categoryHashtag = category?.name?.replaceAll("&", "and");
    const hashtags = ["oumedia", categoryHashtag];
    const {
      showShareTooltip,
      showDeleteConfirmationDialog,
      bookmarked,
      liked,
      score,
      deleteLoading,
    } = this.state;
    const postLines = post.body.split("\n");

    const currentUser = userService.getCurrentUser();

    const result = (
      <Fragment>
        <div className="post" style={{ display: "flex", ...style }}>
          <div className="post-profile-pic">
            <div className="pic-container">
              <img
                src={`${process.env.REACT_APP_BACKEND_API_PATH}/profile/${post.author.username}/pic`}
              />
            </div>
          </div>
          <div className="post-data">
            <div className="post-metadata">
              <Username
                username={post.author.username}
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/profile/${post.author.username}`);
                }}
              />
              <div className="post-date">{getPostDate(post.createDate)}</div>
            </div>
            <div className="post-content">
              <h3 className="heading post-heading">{post.title}</h3>
              <div className="post-body">
                {postLines.map((line, i) => (
                  <p
                    key={i}
                    style={{
                      marginTop: i == 0 ? 0 : "unset",
                      marginBottom: i == postLines.length - 1 ? 0 : "unset",
                    }}
                  >
                    {line}
                  </p>
                ))}
              </div>
            </div>
            {showPostActions && (
              <div className="post-actions">
                <div className="post-action">
                  <ChatBubbleOutlineIcon className="icon" />
                  <span className="text-label">{post.numOfReplies}</span>
                </div>
                <div className="post-action">
                  {liked ? (
                    <IconButton className="icon" onClick={this.toggleLike}>
                      <ThumbUpIcon
                        style={{
                          fontSize: 20,
                        }}
                      />
                    </IconButton>
                  ) : (
                    <IconButton className="icon" onClick={this.toggleLike}>
                      <ThumbUpAltOutlinedIcon
                        style={{
                          fontSize: 20,
                        }}
                      />
                    </IconButton>
                  )}
                  <span
                    className="text-label"
                    style={{
                      marginLeft: 2,
                    }}
                  >
                    {score}
                  </span>
                </div>
                <div className="post-action">
                  {bookmarked ? (
                    <IconButton className="icon" onClick={this.toggleBookmark}>
                      <BookmarkIcon style={{ fontSize: 22 }} />
                    </IconButton>
                  ) : (
                    <IconButton className="icon" onClick={this.toggleBookmark}>
                      <BookmarkBorderOutlinedIcon style={{ fontSize: 22 }} />
                    </IconButton>
                  )}
                </div>
                <div className="post-action">
                  <ClickAwayListener
                    onClickAway={() => this.setShareTooltip(false)}
                  >
                    <div>
                      <HtmlTooltip
                        placement="bottom-end"
                        PopperProps={{
                          disablePortal: true,
                        }}
                        title={
                          <React.Fragment>
                            <Share
                              title={"Check out this post on OuMedia!"}
                              url={postUrl}
                              hashtags={hashtags}
                            />
                          </React.Fragment>
                        }
                        onClose={() => this.setShareTooltip(false)}
                        open={showShareTooltip}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                      >
                        <IconButton
                          className="icon"
                          onClick={(e) => {
                            e.preventDefault();
                            this.setShareTooltip(true);
                          }}
                        >
                          <ShareIcon
                            style={{
                              fontSize: "inherit",
                            }}
                          />
                        </IconButton>
                      </HtmlTooltip>
                    </div>
                  </ClickAwayListener>
                </div>
                {(post.author.username == currentUser.sub ||
                  currentUser.isAdmin) && (
                  <div className="post-action">
                    <IconButton
                      className="icon"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          showDeleteConfirmationDialog: true,
                        });
                      }}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );

    return (
      <Fragment>
        {isLink ? (
          <Link
            to={relativePostUrl}
            style={{ color: "initial", textDecoration: "none" }}
          >
            {result}
          </Link>
        ) : (
          result
        )}
        <Dialog
          open={showDeleteConfirmationDialog}
          onClose={() => {
            this.setState({
              showDeleteConfirmationDialog: false,
            });
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              fontFamily: "inherit",
            }}
          >
            {"Confirm post deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontFamily: "inherit",
              }}
            >
              Are you sure you want to delete your post? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={(e) => {
                this.setState({
                  showDeleteConfirmationDialog: false,
                });
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={this.deletePost}
              loading={deleteLoading}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              autoFocus
              variant="contained"
              color="error"
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default withRouter(withSnackbar(Post));
